import { cx } from "@suse-o11y/class-variance";
import { IconDelete } from "@suse-o11y/icons";
import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";
import { Input } from "~/components/input";

import { Widget } from "../../../_widget";

import type { StaticValueState } from "./_form-state";

export interface StaticValueProps {
	dragHandle: React.ReactNode;
	onDelete: undefined | VoidFunction;
	state: StaticValueState;
	className?: string;
}

export const StaticValue = React.forwardRef<React.ElementRef<typeof Widget>, StaticValueProps>(
	({ dragHandle, onDelete, state, className, ...props }, ref) => {
		const id = React.useId();

		return (
			<Widget card className={cx("grid grid-cols-[max-content_1fr_auto] gap-2", className)} ref={ref} {...props}>
				<FormField className="col-span-full grid grid-cols-subgrid" layout="horizontal" state={state.fields.value}>
					<FormLabel>Value</FormLabel>

					{(monitor, field) => (
						<Input
							name={`dashboard-list-static-variable-${id}-value`}
							onChange={(event) => field.setInput(event.target.value)}
							size="sm"
							value={field.getInput(monitor)}
						/>
					)}

					{dragHandle}

					<FormFieldErrorMessage className="col-start-2" />
				</FormField>

				<FormField className="col-span-full grid grid-cols-subgrid" layout="horizontal" state={state.fields.label}>
					<FormLabel>Label</FormLabel>

					{(monitor, field) => (
						<Input
							name={`dashboard-list-static-variable-${id}-label`}
							onChange={(event) => field.setInput(event.target.value)}
							placeholder={state.fields.value.getOutput(monitor) ?? ""}
							size="sm"
							value={field.getInput(monitor)}
						/>
					)}

					{onDelete != null && (
						<button className="button button-tertiary button-sm button-square" onClick={onDelete} type="button">
							<IconDelete className="size-3" />
						</button>
					)}

					<FormFieldErrorMessage className="col-start-2" />
				</FormField>
			</Widget>
		);
	},
);
